export const LinksSections = {
    '1001': {
        ID: 1001,
        Icon: '',
        Name: 'RESERVA_VEHICULOS_CORTESIA',
        Rights: 1,
        Template: '',
        Title: '',
        Type: 'section',
        Url: '',
        route: '/dms/general/reserva-vehiculos-cortesia',
    },
    '2002': {
        ID: 2002,
        Icon: 'nav_icon_pedidos_piezas',
        Name: 'PEDIDOS_PIEZAS',
        Rights: 1,
        Template: '',
        Title: 'Pedidos de Piezas',
        Type: 'section',
        Url: '',
        route: '/dms/warehouse/pedidos-piezas',
    },
    '2003': {
        ID: 2003,
        Icon: undefined,
        Name: 'ENTRADAS_ALMACEN',
        Rights: 1,
        Template: '',
        Title: 'Entradas Almacén',
        Type: 'section',
        Url: '',
        route: '/dms/warehouse/entradas-almacen'
    },

    '3001': {
        ID: 3001,
        Icon: 'nav_icon_agenda',
        Name: 'AGENDA_CITAS',
        Rights: 1,
        Template: '',
        Title: 'Agenda',
        Type: 'section',
        Url: '',
        route: '/dms/workshop/agendas-citas'
    },
    '3002': {
        ID: 3002,
        Icon: 'nav_icon_recepcion_veh',
        Name: 'RECEPCION_VEHICULO',
        Rights: 1,
        Template: '',
        Title: 'Recepción Vehículo',
        Type: 'section',
        Url: '',
        route: '/dms/workshop/recepcion-vehiculo'
    },
    '3003': {
        ID: 3003,
        Icon: 'nav_icon_gest_or',
        Name: 'GESTION_OR',
        Rights: 1,
        Template: '',
        Title: 'Gestión OR',
        Type: 'section',
        Url: '',
        route: '/dms/workshop/gestion-or'
    },
    '3004': {},
    '4001': {
        ID: 4001,
        Icon: 'nav_icon_facturacion_oper',
        Name: 'FACTURACION_OPERACIONES',
        Rights: 1,
        Template: '',
        Title: 'Facturación Oper.',
        Type: 'section',
        Url: '',
        route: '/dms/invoices/facturacion-operaciones'
    },
    '4005': {
        ID: 4005,
        Icon: 'nav_icon_facturacion_agrupada',
        Name: 'FACTURACION_AGRUPADA',
        Rights: 1,
        Template: '',
        Title: 'Facturación Agrupada',
        Type: 'section',
        Url: '',
        route: '/dms/invoices/facturacion-agrupada'
    },

    '4010': {
        ID: 4010,
        Icon: 'nav_icon_control_pagos_fact_cont',
        Name: 'FACT_GESTIONCOBROS',
        Rights: 1,
        Template: '',
        Title: 'Pagos Fact. Contado',
        Type: 'section',
        Url: '',
        route: '/dms/invoices/pagos-facturas-contado'
    },
    '5001': {
        ID: 5001,
        Icon: 'nav_icon_conect_interfacemarca',
        Name: 'INTERFACES_MARCA',
        Rights: 1,
        Template: '',
        Title: 'Interfaces Marca',
        Type: 'section',
        Url: '',
        route: '/dms/connectivity/interfaces-marca'
    },
    '6001': {
        ID: 6001,
        Icon: 'nav_icon_cont_export',
        Name: 'CONTABILIDAD_EXPORTACION',
        Rights: 1,
        Template: '',
        Title: 'Contabilidad Exportacion',
        Type: 'section',
        Url: '',
        route: '/dms/accounting/contabilidad-exportacion'
    },
    '7004': {
        ID: 7004,
        Icon: 'nav_icon_vo_gestion',
        Name: 'GESTION_VO',
        Rights: 1,
        Template: null,
        Title: 'GestiÃ³n',
        Type: 'section',
        Url: null,
        route: '/dms/vc-vo/gestion-vo'
    }
};


